import i18n from '@/lib/i18n'

export const CATEGORY_TITLE = i18n.t('category.title')
